/**
 * RS Custom Filters
 * JavaScript to handle filtering of products in the RS Custom Filters section
 */

class RSCustomFilters {
  constructor() {
    this.filterButtons = document.querySelectorAll('.rs-custom-filters__item');
    this.productCards = document.querySelectorAll('.rs-custom-products__card');
    
    // Sort bestsellers to appear first
    this.sortBestsellersFirst();
    
    // Initialize event listeners
    this.initEventListeners();
  }
  
  /**
   * Initialize event listeners for filter buttons
   */
  initEventListeners() {
    this.filterButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        // Remove active class from all buttons
        this.filterButtons.forEach(btn => btn.classList.remove('active'));
        
        // Add active class to clicked button
        button.classList.add('active');
        
        // Filter products
        this.filterProducts(button.dataset.productType);
      });
    });
  }
  
  /**
   * Filter products based on selected category with smooth animation
   * @param {string} type - The product type to filter by
   */
  filterProducts(type) {
    // Get container for potential layout adjustments
    const container = document.querySelector('.rs-custom-products__grid');
    
    // First fade out all cards that need to be hidden
    this.productCards.forEach((card, index) => {
      // Determine if this card should be shown or hidden
      let shouldShow = false;
      
      if (type === 'all') {
        shouldShow = true;
      } else {
        const productTypes = card.dataset.productType.split(',').map(t => t.trim());
        shouldShow = productTypes.includes(type);
      }
      
      // Apply appropriate animation classes with staggered timing
      if (!shouldShow) {
        // Fade out non-matching cards with staggered delay
        setTimeout(() => {
          card.classList.add('animate-out');
          card.classList.remove('animate-in');
        }, index * 20); // Stagger the animation start time
      }
    });
    
    // After fade-out animation completes, hide non-matching cards and show matching ones
    setTimeout(() => {
      // Apply hidden class to non-matching cards
      this.productCards.forEach(card => {
        if (type === 'all') {
          card.classList.remove('hidden');
        } else {
          const productTypes = card.dataset.productType.split(',').map(t => t.trim());
          
          if (productTypes.includes(type)) {
            card.classList.remove('hidden');
          } else {
            card.classList.add('hidden');
          }
        }
      });
      
      // Now fade in the visible cards with staggered timing
      const visibleCards = Array.from(this.productCards).filter(card => !card.classList.contains('hidden'));
      
      visibleCards.forEach((card, index) => {
        setTimeout(() => {
          card.classList.add('animate-in');
          card.classList.remove('animate-out');
        }, index * 40); // Stagger the animation start time
      });
      
      // Remove animation classes after all transitions complete
      setTimeout(() => {
        this.productCards.forEach(card => {
          card.classList.remove('animate-in', 'animate-out');
        });
      }, visibleCards.length * 40 + 400);
    }, 300); // Wait for fade-out to complete
  }
  
  /**
   * Sort products to show bestsellers first
   */
  sortBestsellersFirst() {
    const container = document.querySelector('.rs-custom-products__grid');
    if (!container) return;
    
    // Get all product cards
    const cards = Array.from(this.productCards);
    
    // Sort cards: bestsellers first, then regular products
    cards.sort((a, b) => {
      const aIsBestseller = a.hasAttribute('data-bestseller');
      const bIsBestseller = b.hasAttribute('data-bestseller');
      
      if (aIsBestseller && !bIsBestseller) return -1;
      if (!aIsBestseller && bIsBestseller) return 1;
      return 0;
    });
    
    // Remove all cards from container
    cards.forEach(card => card.remove());
    
    // Add cards back in sorted order
    cards.forEach(card => {
      container.appendChild(card);
    });
    
    // Note: We don't need to move the image column as it's now correctly positioned in the HTML
    // outside of the product grid
  }
}

// Initialize on DOM content loaded
document.addEventListener('DOMContentLoaded', () => {
  const rsCustomFiltersSection = document.getElementById('shopify-section-rs-custom-filters');
  
  if (rsCustomFiltersSection) {
    new RSCustomFilters();
  }
});
